import { Condition } from '../interfaces/conditionals'
import { isNullish, isNumber } from './validations'

/**
 * Evaluate a conditional between two values
 * @param value
 * @param condition
 * @param secondValue
 */
export const evalConditional = (
  firstValue: unknown,
  condition: Condition,
  secondValue?: unknown
) => {
  switch (condition) {
    case 'isLessThan': {
      return (
        isNumber(firstValue) &&
        isNumber(secondValue) &&
        firstValue < secondValue
      )
    }
    case 'isLessThanOrEqual': {
      return (
        isNumber(firstValue) &&
        isNumber(secondValue) &&
        firstValue <= secondValue
      )
    }
    case 'isGreaterThan': {
      return (
        isNumber(firstValue) &&
        isNumber(secondValue) &&
        firstValue > secondValue
      )
    }
    case 'isGreaterThanOrEqual': {
      return (
        isNumber(firstValue) &&
        isNumber(secondValue) &&
        firstValue >= secondValue
      )
    }
    case 'isEqual': {
      return firstValue === secondValue
    }
    case 'isNotEqual': {
      return firstValue !== secondValue
    }
    case 'isTruthy': {
      return Boolean(firstValue) === true
    }
    case 'isFalsy': {
      return Boolean(firstValue) === false
    }
    case 'isNullish': {
      return isNullish(firstValue)
    }
    default: {
      return false
    }
  }
}
